export default "__VITE_ASSET__DXDstpXb__"